/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';

const domain = '/administres';
const product = '/etat-civil';

const isNumPath =
  typeof window !== 'undefined' &&
  _.includes(window.location.hostname, 'numerisation');
export const baseUrlApp =
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test' ||
  isNumPath
    ? '/'
    : `${domain}${product}/`;

export const baseUrlApi = `/api${domain}${product}`;
